'use strict';

import type { UserFlow } from '../../Entities/User/UserFlow';
import { EntityCollection } from '../EntityCollection';

export class UserFlowCollection extends EntityCollection<UserFlow> {}
